export default __webpack_public_path__ + "img/1_1-6d4cf17f.png";